module.exports = __webpack_public_path__ + "img/character_resize_blu.9e36c81a.png";